import { useState } from "react";
import SectionHeading from "@/components/feature/SectionHeading";
import { faqs, siteInfo } from "@/mocks/guagua";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full scroll-mt-20 bg-background-50">
      <div className="w-full px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          align="center"
          eyebrow="常见问题"
          title="关于吃瓜合集导航的常见问题"
          description="整理了几个大家问得最多的问题，如果还有别的疑问，欢迎直接发邮件联系我们。"
        />

        <div className="mx-auto mt-10 max-w-3xl divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={faq.q}>
                <h3>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100 md:px-6 md:py-5"
                  >
                    <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">{faq.q}</span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                      }`}
                    >
                      <i
                        className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-lg leading-none`}
                        aria-hidden="true"
                      ></i>
                    </span>
                  </button>
                </h3>
                {isOpen && (
                  <div className="px-5 pb-5 md:px-6 md:pb-6">
                    <p className="text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <p className="mx-auto mt-8 max-w-3xl text-center text-sm text-foreground-600">
          还有别的问题？发邮件到{" "}
          <a href={`mailto:${siteInfo.email}`} className="font-medium text-primary-700 hover:underline">
            {siteInfo.email}
          </a>
          ，我们会尽快回复。
        </p>
      </div>
    </section>
  );
}